module.exports = __webpack_public_path__ + "img/lacoste_content_img_03.bb5c3b3b.jpg";